import { useMemo } from 'react';
import { Definition } from '../types/diagnostic';
import { definitionsToAbnormalities } from '../utils/abnormalities.util';

export const useTypedAbnormalities = (definitions: Definition[]) =>
  useMemo(() => definitionsToAbnormalities(definitions), [definitions]);
